import { fetchPopularDevices } from '@gn-audio/core/api/compatibility-guide/fetch-popular-devices';
import { fetchSearch } from '@gn-audio/core/api/compatibility-guide/fetch-search';
import { isArray, isFunction, isString } from 'angular';
var DeviceSearchComponentController = (function () {
    function DeviceSearchComponentController($q) {
        this.$q = $q;
        this.devices = [];
        this.loading = false;
        this.selectedDevice = null;
        this.showPopular = true;
    }
    DeviceSearchComponentController.prototype.$onInit = function () {
        var _this = this;
        this.$q
            .when(fetchPopularDevices())
            .then(function (popularDevices) {
            if (isArray(_this.excludedDevices)) {
                _this.popularDevices = popularDevices.filter(function (d) {
                    return !_this.excludedDevices.some(function (excludedSearchKey) { return d.searchKey === excludedSearchKey; });
                });
            }
            else {
                _this.popularDevices = popularDevices;
            }
        });
    };
    DeviceSearchComponentController.prototype.isSelectedDevice = function (device) {
        return this.selectedDevice === device;
    };
    DeviceSearchComponentController.prototype.queryChanged = function () {
        var _this = this;
        this.selectedDevice = null;
        if (!isString(this.query) || this.query.length < 3) {
            this.devices.length = 0;
            this.showPopular = true;
            return;
        }
        this.loading = true;
        this.showPopular = false;
        this.$q
            .when(fetchSearch(this.query))
            .then(function (devices) {
            if (isArray(_this.excludedDevices)) {
                _this.devices = devices.filter(function (d) {
                    return !_this.excludedDevices.some(function (excludedSearchKey) { return d.searchKey === excludedSearchKey; });
                });
            }
            else {
                _this.devices = devices;
            }
            _this.devices.sort(function (a, b) {
                if (a.manufacturer < b.manufacturer) {
                    return -1;
                }
                if (a.manufacturer > b.manufacturer) {
                    return 1;
                }
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    DeviceSearchComponentController.prototype.selectDevice = function (device) {
        this.selectedDevice = device;
    };
    DeviceSearchComponentController.prototype.handleEvent = function ($event) {
        switch ($event.keyCode) {
            case 38:
                $event.preventDefault();
                this.handleKeyUp(this.showPopular ? this.popularDevices : this.devices);
                break;
            case 40:
                $event.preventDefault();
                this.handleKeyDown(this.showPopular ? this.popularDevices : this.devices);
                break;
            case 13:
            case undefined:
                $event.preventDefault();
                if (this.selectedDevice === undefined) {
                    return;
                }
                if (!isFunction(this.onDevicesSelected)) {
                    return;
                }
                this.onDevicesSelected({ devices: [this.selectedDevice] });
                break;
            default:
                break;
        }
    };
    DeviceSearchComponentController.prototype.handleKeyUp = function (devices) {
        var deviceIndex = devices.indexOf(this.selectedDevice);
        if (deviceIndex === -1 || deviceIndex === 0) {
            return;
        }
        this.selectedDevice = devices[deviceIndex - 1];
    };
    DeviceSearchComponentController.prototype.handleKeyDown = function (devices) {
        if (this.selectedDevice === null) {
            this.selectedDevice = devices[0];
            return;
        }
        var deviceIndex = devices.indexOf(this.selectedDevice);
        if (deviceIndex === -1) {
            return;
        }
        if (deviceIndex === devices.length - 1) {
            return;
        }
        this.selectedDevice = devices[deviceIndex + 1];
    };
    DeviceSearchComponentController.$inject = ['$q'];
    return DeviceSearchComponentController;
}());
export var DeviceSearchComponent = {
    bindings: {
        excludedDevices: '<?',
        onDevicesSelected: '&?',
    },
    controller: DeviceSearchComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/devicesearch',
};
